import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { HOMECARD_IMAGE_SIZES } from '../../constants';

import withFavorites from '../withFavorites';
import { SMALL_MAP } from '../withStaticMap';

import Homecard from './Homecard';
import { generateHomeCardLabels } from './generateHomeCardLabels';

const getDatesQuery = (moveIn, moveOut) => {
  let getParams = [];
  getParams = moveIn ? [...getParams, `move-in=${moveIn}`] : getParams;
  getParams = moveOut ? [...getParams, `move-out=${moveOut}`] : getParams;

  return getParams.length ? `?${getParams.join('&')}` : '';
};

const getClassName = (visited, selected, tracking) =>
  classNames(
    'home-card',
    'is-animated',
    {
      'home-card--visited': visited,
      'home-card--selected': selected
    },
    tracking
  );

const getUrl = (url, moveIn, moveOut) =>
  `${url}${getDatesQuery(moveIn, moveOut)}`;

const getRating = (reviews = {}) =>
  reviews.ratingAverage ? reviews.ratingAverage : false;

const generateImageSet = photoUrls =>
  Object.keys(photoUrls)
    .filter(size => photoUrls[size] && HOMECARD_IMAGE_SIZES[size])
    .map(size => `${photoUrls[size]} ${HOMECARD_IMAGE_SIZES[size]}`);

class HomeCard extends Component {
  static propTypes = {
    coord: PropTypes.array,
    currency: PropTypes.object.isRequired,
    data: PropTypes.shape({
      adId: PropTypes.string,
      checked: PropTypes.bool,
      id: PropTypes.string,
      mainPhotoUrl: PropTypes.string,
      monthlyPrice: PropTypes.shape({
        type: PropTypes.string,
        minimumPrice: PropTypes.number
      }),
      photoUrls: PropTypes.shape({
        homecardHidpi: PropTypes.string,
        homecard: PropTypes.string
      }),
      reviews: PropTypes.shape({
        ratingAverage: PropTypes.number
      }),
      title: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string,
      visited: PropTypes.bool
    }).isRequired,
    disabled: PropTypes.bool,
    handleFavorite: PropTypes.func.isRequired,
    isFavorite: PropTypes.bool.isRequired,
    moveIn: PropTypes.string,
    moveOut: PropTypes.string,
    onCardMouseEnter: PropTypes.func,
    onCardMouseLeave: PropTypes.func,
    onClick: PropTypes.func,
    overflow: PropTypes.bool,
    pointOfInterest: PropTypes.object,
    selected: PropTypes.bool,
    tracking: PropTypes.string
  };

  static defaultProps = {
    disabled: false,
    isVariant: false,
    moveIn: '',
    moveOut: '',
    onCardMouseEnter: () => {},
    onCardMouseLeave: () => {},
    onClick: () => {},
    overflow: false,
    selected: false,
    tracking: ''
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.selected !== nextProps.selected ||
      this.props.isFavorite !== nextProps.isFavorite
    );
  }

  getHomecard = () => {
    const {
      currency,
      data: ad,
      disabled,
      handleFavorite,
      isFavorite,
      moveIn,
      moveOut,
      onClick,
      overflow,
      selected
    } = this.props;
    const { photoUrls } = ad;
    const adUrl = getUrl(ad.url, moveIn, moveOut);

    return {
      disabled, // TODO: this might be treated in the patternLibrary
      favourite: isFavorite, // TODO: review if necessary
      availableFrom: ad.firstAvailableDate,
      handleFavourite: handleFavorite,
      image: ad.mainPhotoUrl,
      imageSet: photoUrls ? generateImageSet(photoUrls) : '',
      isFavorite,
      link: adUrl,
      onClick,
      onMouseEnter: this.handleMouseEnter, // TODO: this might be treated in the patternLibrary
      onMouseLeave: this.handleMouseLeave, // TODO: this might be treated in the patternLibrary
      overflow,
      price: {
        type: ad.monthlyPrice.type,
        amount: ad.monthlyPrice.minimumPrice,
        currencyCode: currency.getIsoCode()
      },
      rating: getRating(ad.reviews),
      renderLabels: generateHomeCardLabels(ad),
      selected, // TODO: this might be treated in the patternLibrary
      title: ad.title,
      type: ad.type,
      verified: ad.checked
    };
  };

  handleMouseEnter = () => {
    this.props.onCardMouseEnter(this.props.data.id);
  };

  handleMouseLeave = () => {
    this.props.onCardMouseLeave(this.props.data.id);
  };

  renderHomecard = () => {
    const { coord, pointOfInterest } = this.props;
    const homecard = this.getHomecard();

    return (
      <Homecard
        coords={coord}
        size={SMALL_MAP}
        pointOfInterest={pointOfInterest}
        homecard={homecard}
      />
    );
  };

  render() {
    const { data: ad, selected, tracking } = this.props;
    const classes = getClassName(ad.visited, selected, tracking);

    return (
      <div
        className={classes}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {this.renderHomecard()}
      </div>
    );
  }
}

export default withFavorites()(HomeCard);
